import {createFileRoute, redirect} from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/meals/new')({
  beforeLoad: () => {
    throw redirect({to: '/tracking/meals/new', replace: true});
  },
});
